import { 
    apiRequest,
    admindiklatList,
    admindiklatActive,
    admindiklatInactive,
    admindiklatHours,
    admindiklatApprove,
    masterRegion
 } from "../../../../../../../services/adapters/kepegawaian/diklatService"

class DiklatRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", admindiklatList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchRowTableAdmin = async (query, cancelToken) => {
        return await apiRequest("get", admindiklatList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", admindiklatInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", admindiklatActive, {
            body: query
        }, true)
    }

    fetchHours = async (query, cancelToken) => {
        return await apiRequest("get", admindiklatHours, {
            cancelToken: cancelToken,
            params: query
        }, true);
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", admindiklatApprove, {
            body: query
        }, true)
    }

    fetchRegion = async (query, cancelToken) => {
        return await apiRequest("get", masterRegion, {
            cancelToken: cancelToken,
            params: query
        }, true);
    }


    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }


}

export default DiklatRepository
